<template>
    <div
      class="as-match-item"
      :class="{
        'as-match-item-sm': screenWidth < 360,
      }"
    >
      <div class="as-match-item__header">
        <div class="as-match-item__league">
          <!-- <SkeletonLoader width="21px" height="21px" :line="1" mode="circle" /> -->
          <SkeletonLoader width="80px" height="20px" :line="1" />
        </div>
        <div class="as-match-item__time as-match-item__status--normal">
          <SkeletonLoader class="as-icon-haflt as-icon-haflt-loading" width="106px" height="26px" :line="0"
            :style="{
              marginTop: '-8px',
              borderBottomLeftRadius: '50%',
              borderBottomRightRadius: '50%',
            }"
          />
        </div>
          
        <SkeletonLoader  width="80px" height="20px" :line="1" />
      </div>
      <div class="as-match-item__body">
        <div class="as-match-item__team as-match-item__team-home as-team--home">
          <!-- <SkeletonLoader width="28px" height="28px" :line="1" mode="circle" /> -->
          <SkeletonLoader width="65px" height="20px" :line="1" />
        </div>
        <div
          class="as-scoreboard"
        >
          <SkeletonLoader width="40px" height="40px" :line="1" mode="circle"  />
        </div>

        <div class="as-match-item__team as-match-item__team-away as-team--away">
          <!-- <SkeletonLoader width="28px" height="28px" :line="1" mode="circle" /> -->
          <SkeletonLoader width="65px" height="20px" :line="1" />
        </div>
      </div>
      <div class="as-match-item__footer">
        <div
          class="as-flag as-d-flex"
        >
          <div class="as-flag__goal-scoring as-d-flex">
            <SkeletonLoader width="40px" height="16px" :line="1" />
          </div>
          <div class="as-flag__corner-ball as-d-flex">
            <SkeletonLoader width="40px" height="16px" :line="1" />
          </div>
          <div class="as-flag__yellow-card as-d-flex">
            <SkeletonLoader width="40px" height="16px" :line="1" />
          </div>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";

const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

interface IProps {
  isHomePage?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);
</script>

<script lang="ts">
export default {};
</script>

